import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule,FormsModule } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { EditorModule } from 'primeng/editor';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MenuModule } from "primeng/menu";
import { MenubarModule } from "primeng/menubar";
import { MessageModule } from "primeng/message";
import { ButtonModule } from "primeng/button";
import { MessagesModule } from "primeng/messages";
import { TabMenuModule } from "primeng/tabmenu";
import { TooltipModule } from "primeng/tooltip";
import { StepsModule } from "primeng/steps";
import { PanelModule } from "primeng/panel";
import { DropdownModule } from "primeng/dropdown";
import { TabViewModule } from "primeng/tabview";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { FileUploadModule } from "primeng/fileupload";
import { CalendarModule } from "primeng/calendar";
import { DialogModule } from "primeng/dialog";
import { RadioButtonModule } from "primeng/radiobutton";
import { CheckboxModule } from "primeng/checkbox";
import { ToolbarModule } from "primeng/toolbar";
import { ListboxModule } from "primeng/listbox";
import { ColorPickerModule } from "primeng/colorpicker";
import { SharedModule } from '../shared.module';
import { ToastModule } from 'primeng/toast';
import { DataViewModule } from 'primeng/dataview';
import { TableModule, TableService } from 'primeng/table';
import { FullCalendarModule } from '@fullcalendar/angular';

@NgModule({
  declarations: [],
  imports: [
    SharedModule,
    ToolbarModule,
    DataViewModule,
    FormsModule,
    ReactiveFormsModule,
    TabMenuModule,
    ToastModule,
    FullCalendarModule,
    CalendarModule,
    PanelModule,
    TabViewModule,
    DialogModule,
    TableModule,
    CommonModule,
    DropdownModule,
  ]
})
export class FeesManagementModule { }
